import { CategoryModel } from '../../../../features/category/interfaces/category.model';
import { ConnectionTypeEnum } from '../../../types/ConnectionType';
import { Attendance } from '../../attendance/models/Attendance.models';
import { Company } from '../../company/models/Company.model';
import { Employee } from '../../employee/models/Employee.model';
import { TemplateModel } from '../../performance/models/PerformanceCategory.models';
import { ApiResponse } from '../../shared/models/ApiResponse.model';
import { Team } from '../../team/models/Team.model';
import { User } from '../../user/models/User.model';
import { DisciplineStep } from './DisciplineStep.models';

export enum DisciplineStatusEnum {
	'Draft' = 'Draft',
	'RequestedChange' = 'RequestedChange',
	'RequestedApproval' = 'RequestedApproval',
	'DisciplineDeclined' = 'DisciplineDeclined',
	'Approved' = 'Approved',
	'IssuedToEmployee' = 'IssuedToEmployee',
	'SubmittedToHr' = 'SubmittedToHr',
	'ReceivedByHr' = 'ReceivedByHr',
	'DocumentationFiled' = 'DocumentationFiled',
}

export enum DisciplineStatusForHumansEnum {
	'Draft' = 'Draft',
	'RequestedChange' = 'Change requested by approver',
	'RequestedApproval' = 'Requested approval',
	'DisciplineDeclined' = 'Discipline declined by approver',
	'Approved' = 'Approved, ready to issue to employee',
	'IssuedToEmployee' = 'Issued to employee',
	'SubmittedToHr' = 'Submitted to HR',
	'ReceivedByHr' = 'Received by HR',
	'DocumentationFiled' = 'Documentation filed',
}

export type DisciplineStatusType =
	DisciplineStatusEnum.Draft |
	DisciplineStatusEnum.RequestedChange |
	DisciplineStatusEnum.RequestedApproval |
	DisciplineStatusEnum.DisciplineDeclined |
	DisciplineStatusEnum.Approved |
	DisciplineStatusEnum.IssuedToEmployee |
	DisciplineStatusEnum.SubmittedToHr |
	DisciplineStatusEnum.ReceivedByHr |
	DisciplineStatusEnum.DocumentationFiled;

export enum DisciplineActions {
	Delete = 'DELETE',
	Print = 'PRINT',
	Save = 'SAVE',
	NoChange = 'NO_CHANGE',
	Draft = 'DRAFT',
	Decline = 'DECLINE',
	RequestChanges = 'REQUEST_CHANGES',
	Approve = 'APPROVE',
	RequestApproval = 'REQUEST_APPROVAL',
	Issue = 'ISSUE',
	Submit = 'SUBMIT',
	Receive = 'RECEIVE',
	FastFile = 'FAST_FILE',
}

export type DisciplineStatusActions = Exclude<DisciplineActions, DisciplineActions.Delete |  DisciplineActions.Print |  DisciplineActions.Save |  DisciplineActions.NoChange>

export interface Discipline {
	id: number;
	tenant_id: string;
	created_at: string;
	updated_at: string;
	status: DisciplineStatusType;
	supervisorNote: string;
	isSigned: boolean;
	closed_at: string;
	overwritten_at: string;
	stepId?: number;
	step: DisciplineStep;
	employeeId?: number;
	employee: Employee;
	teamId: number;
	team: Team;
	creatorId: number;
	creator: User;
	reviewerId: number;
	reviewer: User;
	company: Company;
	connectionType: ConnectionTypeEnum.Discipline;
	date: string;
	templateId: number;
	// only returned on the findOne discipline call
	template?: TemplateModel;
	categoryId: number;
	category?: CategoryModel;
	infractions: (Attendance|Discipline)[];
	textFields: DisciplineTextFields;
	changes: string;
	category_id: number;
	metadata?: any;
}

export interface DisciplineTextFields {
	incidentDetails: string;
	expectations: string;
	consequences: string;
};

export type DisciplineTextFieldType = 'incidentDetails' | 'expectations' | 'consequences';

export interface DisciplineCreate {
	date: string;
	stepId: number;
	employeeId: number;
	teamId: number;
	reviewerId?: number;
	supervisorNote?: string;
	templateId: number;
	infractions: string;
	textFields: string;
	category_id: number;
	metadata?: any;
	creatorId?: number;
	status?: DisciplineStatusType;
	// for RequestedChanges only
	changes?: string;
}
